import { render, staticRenderFns } from "./ArticoliDetails.vue?vue&type=template&id=a940bcde&scoped=true"
import script from "./ArticoliDetails.vue?vue&type=script&lang=js"
export * from "./ArticoliDetails.vue?vue&type=script&lang=js"
import style0 from "./ArticoliDetails.vue?vue&type=style&index=0&id=a940bcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a940bcde",
  null
  
)

export default component.exports